export const FIND_STATEMENT_TEMPLATE_PLACEHOLDERS_FAILURE = 'FIND_STATEMENT_TEMPLATE_PLACEHOLDERS_FAILURE';

export const findStatementProcessPlaceholdersFailure = error => ({
    type: FIND_STATEMENT_TEMPLATE_PLACEHOLDERS_FAILURE,
    payload: error,
    error: true,
});
